import { SDate } from '@summit/core';
import dayjs from 'dayjs';
import { Duration } from 'dayjs/plugin/duration';
import { EboObjectTimePeriod } from '../base-classes/ebo-object-time-period';
import { Employee } from '../employee/employee';

export class MaintEventTimeLog extends EboObjectTimePeriod {
  maintEventId: string;
  mechanicId: string;
  mechanic: Employee;
  notes: string;

  constructor(json?: Partial<MaintEventTimeLog>) {
    super(json);
    if (json) {
      if (json.mechanic) {
        this.mechanic = new Employee(json.mechanic);
      }
    }

    if (!json?.startTime) this.startTime = SDate.newUtc();
  }

  get duration(): Duration {
    return dayjs.duration((this.endTime ?? SDate.new()).diff(this.startTime));
  }
}
